import React, { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const RevealLines = ({ lines, className = "", as = "h2", delay = 0 }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as];
  return (
    <Tag className={className} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-40px" }}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className="block" variants={{ hidden: reduce ? { opacity: 0 } : { y: "105%" }, show: reduce ? { opacity: 1 } : { y: 0 } }}
            transition={{ duration: 1.2, delay: delay + i * 0.12, ease: EASE }}>{l}</motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Parallax = ({ src, alt, className = "", strength = 10, imgClassName = "" }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img src={src} alt={alt} style={reduce ? {} : { y, scale: 1 + strength / 45 }} className={`absolute inset-0 w-full h-full object-cover ${imgClassName}`} />
    </div>
  );
};

export default Reveal;
